import React, { useEffect, useState } from "react";
import MonthlyRevenueChart from "./monthlyRevenueChart";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";

const MonthlyRevenue = () => {
  const [monthlyRevenue, setMonthlyRevenue] = useState({});
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // Default to current month
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Default to current year

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/incentive/getRevenueGenratedMonthly?month=${selectedMonth}&year=${selectedYear}`)
      .then((res) => {
        if (res.status === 200) {
          setMonthlyRevenue(res?.data?.monthlyRevenue);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [selectedMonth, selectedYear]);

  if (loading) {
    return <LoadingPage />;
  }

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const getMonthName = (monthIndex) => {
    return new Date(0, monthIndex).toLocaleString('default', { month: 'long' });
  };


  return (
    <div className="container py-4">
       <div className="flex gap-2 mt-2 md:mt-0 p-2">
          {/* Year Selector */}
          <select
            className="border p-2 rounded p-2"
            value={selectedYear}
            onChange={handleYearChange}
          >
            {/* Assuming 2022 to current year as the available options */}
            {Array.from({ length: 5 }, (_, index) => 2022 + index).map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>

          {/* Month Selector */}
          <select
            className="border p-2 rounded"
            value={selectedMonth}
            onChange={handleMonthChange}
          >
            {Array.from({ length: 12 }, (_, index) => (
              <option key={index} value={index + 1}>
                {getMonthName(index)} {/* Convert 0-indexed to 1-indexed */}
              </option>
            ))}
          </select>
        </div>
      <MonthlyRevenueChart data={monthlyRevenue} />
    </div>
  );
};

export default MonthlyRevenue;
